import { Box, FormControlLabel, Grid, Radio, Typography } from "@mui/material";
import { isNotNull } from "../../../../utils/validation";
import { inputValueToInt } from "../../../../utils/utils";

const formTitleWidth = 210;
/**
 * 対象販売原票オプション
 */
const TARGET_SALES_RECORD_OPTIONS = {
  /** 登録・変更後の未印刷分 */
  ONLY_UNPRINTED: "0",
  /** 全件 */
  ALL: "1",
}

/**
 * 売立通知書　帳票印刷設定フォーム
 */
const SalesNotificationSettingForm = ({printParameterInput}) => {

  const onChangePropValue = (propName) => (value) => {
    printParameterInput.setPropValue(propName, value);
  };

  return (
    <Box>
      <Typography fontSize={20} fontWeight='bold'>売立通知書 帳票印刷設定</Typography>

      <Box mt={2}>
        <Grid container alignItems='center' spacing={2}>
          <Grid item width={formTitleWidth}>
            <Typography>出力対象の販売原票情報</Typography>
          </Grid>
          <Grid item xs='auto'>
            <TargetSalesRecordRadio
              value={TARGET_SALES_RECORD_OPTIONS.ONLY_UNPRINTED}
              check={printParameterInput.value.targetSalesRecordCd}
              setValue={onChangePropValue('targetSalesRecordCd')}
              label="登録・変更後の未印刷分"
            />
          </Grid>
          <Grid item xs='auto'>
            <TargetSalesRecordRadio
              value={TARGET_SALES_RECORD_OPTIONS.ALL}
              check={printParameterInput.value.targetSalesRecordCd}
              setValue={onChangePropValue('targetSalesRecordCd')}
              label="全件"
            />
          </Grid>
        </Grid>
      </Box>

    </Box>
  );
};

export default SalesNotificationSettingForm;

/**
 * 売立通知書入力初期値 
 */
export const salesNotificationDefaultParameter = {
  targetSalesRecordCd : TARGET_SALES_RECORD_OPTIONS.ONLY_UNPRINTED,
}

/**
 * 売立通知書入力値バリデーション
 */
export const validateSalesNotification = (formValue) => {
  
  return (
    isNotNull(formValue.targetSalesRecordCd)
      && Object.values(TARGET_SALES_RECORD_OPTIONS).includes(formValue.targetSalesRecordCd)
)};

/**
 * 売立通知書フォームの値を返す
 */
export const returnSalesNotificationParameter = (formValue) => (formValue && formValue.targetSalesRecordCd ? {
  targetSalesRecordCd: inputValueToInt(formValue.targetSalesRecordCd)
} : null);

/**
 * 出力対象の販売原票情報　ラジオボタンフォームコントロール
 */
const TargetSalesRecordRadio = ({value, check, setValue, label}) => (
    <FormControlLabel
      label={label}
      sx={{marginLeft: 1}}
      control = {
        <Radio
          value={value}
          checked={value && check == value}
          onChange={(e) => setValue(e.target.value)}
        />
      }
    />
);
